import { createRef } from 'react'
import { Button, Tooltip } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import openNotification from '../common/Notification/openNotification '

export function configHeaders() {
  return {
    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
}

const AuthenticatedLink = ({ url, filename, disabled = false, type = 0 }) => {
  const link = createRef()

  // const handleAction = async () => {
  //   debugger
  //   fetch(url, {
  //     headers: configHeaders()
  //   })

  //     .then((res) => {
  //       return res.blob()
  //     })
  //     .then((blob) => {
  //       const href = window.URL.createObjectURL(blob)
  //       const link = document.createElement('a')
  //       link.href = href
  //       const fileName = `${filename}_${new Date().toLocaleDateString()}.xlsx`
  //       link.setAttribute('download', fileName)
  //       document.body.appendChild(link)
  //       link.click()
  //     })
  // }

const handleAction = async () => {
  try {
    const response = await fetch(url, {
      headers: configHeaders()
    });

    if (!response.ok) {
      // Nếu response không OK, cố gắng đọc JSON và lấy message
      const contentType = response.headers.get("Content-Type");

      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        const errorMessage = errorData.message || "Đã xảy ra lỗi khi xuất file.";
        openNotification('error', errorMessage || "Xuất file thất bại. Vui lòng thử lại sau.")
      } else {
        const errorText = await response.text();
        const jsonObj = JSON.parse(errorText);
        openNotification('error', jsonObj.message || "Xuất file thất bại. Vui lòng thử lại sau.")
      }

      return;
    }

    // Nếu response OK, xử lý export
    const blob = await response.blob();
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    const fileName = `${filename}_${new Date().toLocaleDateString()}.xlsx`;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(href);
  } catch (error) {
    openNotification('error', jsonObj.message || "Xuất file thất bại. Vui lòng thử lại sau.")
  }
};

  return (
    <>
      <a role="button" ref={link} onClick={() => handleAction()}>
        {type == 1 ? (
          <Tooltip title={disabled ? 'Vui lòng chọn Sàn' : ''}>
            <Button type="primary" disabled={disabled}>
              <DownloadOutlined />
              Export
            </Button>
          </Tooltip>
        ) : (
          <Button type="primary" disabled={disabled}>
            <DownloadOutlined />
            Export
          </Button>
        )}
      </a>
    </>
  )
}

export default AuthenticatedLink
